import { Component } from 'vue-property-decorator';
import Vue from 'vue';
Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave', 'beforeRouteUpdate']);
/**
 * 组件装饰器
 */
export * from 'vue-property-decorator';
export * from '@tencent/vue-shallow';
export { Vue };
/**
 * 浅层依赖，针对数组和大json进行优化，只有target.propertyKey = newValue 才能触发更新 , target.propertyKey.xxx无法触发vue组件更新
 * @param target
 * @param propertyKey
 */
export function StateShallow(target, propertyKey) {
  Object.defineProperty(target, propertyKey, {
    get() {
      if (process.env.NODE_ENV !== 'production') {
        throw new Error(`This property [${propertyKey}] must be initialized`);
      }
    },
    set(value) {
      // @ts-ignore
      Vue.util.defineReactive(this, propertyKey, value, undefined, true);
    },
    enumerable: true,
    configurable: true
  });
}
//# sourceMappingURL=index.js.map
